import React, {Fragment} from 'react';

export default function SocialNetworks(props) {
    return (
        <Fragment>
            <a href="https://stackoverflow.com/users/4017501/cutiko" target="_blank" rel="noopener noreferrer">StackOverflow</a>
            <a href="https://github.com/cutiko" target="_blank" rel="noopener noreferrer">Github</a>
            <a href="https://www.linkedin.com/in/cutiko/" target="_blank" rel="noopener noreferrer">Linkedin</a>
            <a href="https://twitter.com/CutikoLive" target="_blank" rel="noopener noreferrer">Twitter</a>
        </Fragment>
    );
}


// WEBPACK FOOTER //
// ./src/visitors/components/SocialNetworks.js